import floatingLabel from './floating-label';
import customSelect from './custom-select';

let form = {

    init: function() {
        floatingLabel.init();
        customSelect.init();
    }

};

export default form;


// WEBPACK FOOTER //
// ./src/js/components/form.js